// src/api/propertiesApi.js
import { authFetch } from './client';

export const fetchProperties = async (filters = {}) => {
  const qs = new URLSearchParams(filters);
  const res = await authFetch(`/properties/search?${qs.toString()}`);
  if (!res.ok) throw new Error('Error al obtener las propiedades');
  return res.json();
};

export const generateReport = async (filters) => {
  const res = await authFetch(`/properties/generate_report`, {
    method: 'POST',
    body: JSON.stringify(filters),
  });
  if (!res.ok) throw new Error('Error al generar el informe');
  return res.json();
};

export const generateReportSummary = async (properties, user_prompt) => {
  const res = await authFetch(`/reports/summary`, {
    method: 'POST',
    body: JSON.stringify({ properties, user_prompt }),
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.detail || 'Error generando el informe');
  }
  return res.json();
};

export const validateToken = async () => {
  try {
    const res = await authFetch(`/validate-token`, { method: 'GET' });
    return res.ok;
  } catch {
    return false;
  }
};

// NUEVAS para sesiones
export const getSession = (sessionId) =>
  authFetch(`/reports/sessions/${sessionId}`).then(r => {
    if (!r.ok) throw new Error('No se pudo recuperar la sesión');
    return r.json();
  });

export const updateSession = (sessionId, data) =>
  authFetch(`/reports/sessions/${sessionId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  }).then(r => {
    if (!r.ok) throw new Error('No se pudo actualizar la sesión');
    return r.json();
  });

export const createSession = async (filters) => {
  const res = await authFetch(`/reports/create-session`, {
    method: 'POST',
    body: JSON.stringify({ filters }),
  });
  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.detail || 'Error al crear sesión');
  }
  return res.json(); // { session_id }
};

export const getUserProfile = async () => {
  const res = await authFetch(`/reports/user-profile`);
  if (!res.ok) throw new Error('No se pudo obtener el perfil de usuario');
  return res.json();
};

const PANEL_API_URL = (
  process.env.REACT_APP_PANEL_API_URL ||
  process.env.NODE_APP_PANEL_URL ||
  ''
).replace(/\/$/, '');

/** Email embebido en el JWT del panel (disponible al instante, sin round-trip). */
export function getEmailFromAuthToken() {
  try {
    const token = localStorage.getItem('auth_token');
    if (!token) return '';
    const base64 = token.split('.')[1]?.replace(/-/g, '+').replace(/_/g, '/');
    if (!base64) return '';
    const payload = JSON.parse(atob(base64));
    return typeof payload.email === 'string' ? payload.email : '';
  } catch {
    return '';
  }
}

export function resolveDisplayName({ name, email } = {}) {
  const trimmed = (name || '').trim();
  if (trimmed) return trimmed;
  const mail = (email || getEmailFromAuthToken()).trim();
  if (mail) return mail.split('@')[0];
  return '';
}

async function fetchPanelAuthMe() {
  if (!PANEL_API_URL) return null;
  const token = localStorage.getItem('auth_token') || '';
  if (!token) return null;
  const res = await fetch(`${PANEL_API_URL}/auth/me`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });
  if (!res.ok) return null;
  return res.json();
}

/** Perfil unificado: app ACM + panel como respaldo para créditos/plan. */
export async function loadUserCreditContext() {
  let profile = null;
  try {
    profile = await getUserProfile();
  } catch {
    profile = null;
  }

  let panelUser = null;
  if (!profile) {
    try {
      const panel = await fetchPanelAuthMe();
      panelUser = panel?.user ?? null;
    } catch {
      panelUser = null;
    }
  }

  return {
    available: Number(profile?.tokens_assigned ?? panelUser?.tokens_assigned ?? 0),
    name: profile?.name || "",
    plan: profile?.plan || panelUser?.plan || 'legacy',
    weeklyQuota: profile?.weekly_quota ?? null,
    monthlyTokens: profile?.monthly_tokens ?? null,
    credit_token: profile?.credit_token,
  };
};